import React, { FC } from 'react';
import { Provider } from 'react-redux';
import store from '../../../../store/index';

const Store: FC = ({ children }) => {
    return <Provider store={store}>{children}</Provider>;
};

export default Store;
